import React, { useEffect, useState } from "react";
import p_nav_previous from "../../Assets/Images/p_nav_previous.svg";
import { useNavigate, useLocation, Link } from "react-router-dom"; // Import useLocation here
import axiosInstance from "../../Services/axios";
import "./LoyaltyOffer.css";
import Lottie from "lottie-react";
import empotyLottie from "../../Assets/lottieFiles/emptybox.json"
import pingleUserIcon from "../../Assets/Images/Pingle _UserCoin 1.svg";
// Pingle _UserCoin 1.svg"
import placeholderImage from "../../Assets/Images/default-placeholder.png";
import { toast } from "react-toastify";
import NodeaxiosInstance from "../../Services/nodeaxios";
import { useSelector } from "react-redux";
import { showToast } from "../../Components/toastConfig/ToastConfig";
import { getUserReferralLoyaltyDetails } from "../../Services/api";

const LoyaltyOffer = () => {
  const navigate = useNavigate();
  const [pageLoading, setPageLoading] = useState(false);
  const state = useSelector((state) => state);
  const [userData, serUserData] = useState(state?.userAuth?.user);
  let headers = { Authorization: userData?.token };


  const [loyaltyData, setLoyaltyData] = useState({
    referal_eligble_offer_count: 0,
    referal_eligble_offers: [],
    referal_unlock_offers: [],
  });

  useEffect(() => {
    getLoyaltyOffers();
    localStorage.removeItem("loyaltyDetail");
  }, []);

  const getLoyaltyOffers = () => {
    getUserReferralLoyaltyDetails()
      .then((res) => {
        setLoyaltyData(res.data);
      })
      .catch((err) => {
        if (err.response?.status == 400 || err.response?.status == 500) {
          showToast(err.response.data.message || "Something went wrong. Please try again.");
        }
      })
      .finally(() => {
        setPageLoading(true);
      });
  };


  const setLoyaltyDetail = (offerid) => {
    let loyaltyDetail = { 'offerId': offerid }
    localStorage.setItem('loyaltyDetail', JSON.stringify(loyaltyDetail));
    // navigate('/singleLoyaltydetails', { state: { flowparent: 'pingleloyalty' } })
    navigate('/SingleRefrelPointsdetail', { state: { flowparent: 'pingleloyalty' } });

  }


  return (
    <div className="scroller-style-y">
      <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white">
        <div className="d-flex justify-content-between align-items-center ms-2 me-2">
          <img
            src={p_nav_previous}
            width={"24px"}
            height={"16px"}
            alt="Previous Button"
            role="button"
            onClick={() => navigate(-1)}
          />
          <div className="ff-balooPaaji2-bold fs-20 ms-2 ps-1">Offer</div>
        </div>
      </div>

      <div className="p-2 ms-2">
        <div className="ms-2">
          <p className="ff-poppins-bold p-0 fs-24 secondary-text m-0">Pingle</p>
          <p className="ff-poppins-regular p-0 fs-16 secondary-text-1">
            Loyalty Offers
          </p>
        </div>
        <div>
          {
            pageLoading ?
              loyaltyData.referal_eligble_offers.length > 0 || loyaltyData.referal_unlock_offers.length > 0 ?
                <>
                  {
                    loyaltyData.referal_eligble_offers.length > 0 ?
                      <div className="pingleOfferHero" id="availbleofferid">
                        <div className="pinglerOfferItemsCardsDiv">
                          <div className="fw-bold pb-3 fs-5">
                            {loyaltyData.referal_eligble_offer_count} Offers for You!
                          </div>
                          <div className="row gx-2">
                            {loyaltyData.referal_eligble_offers.map((offers, index) => (
                              // <div className="col-6 mb-3" key={index}>
                              //   <div className="pingleOfferCardBox d-flex flex-column h-100">

                              //     {/* Image */}
                              //     <div className="offerImageWrapper">
                              //       <img
                              //         src={
                              //           offers.offer_images.length > 0
                              //             ? offers.offer_images[0]
                              //             : placeholderImage
                              //         }
                              //         onError={(event) => {
                              //           event.target.onerror = null;
                              //           event.target.src =
                              //             "https://pingle.s3.ap-south-1.amazonaws.com/uploads/vendor/profile/user.jpg";
                              //         }}
                              //         alt="Offer"
                              //         className="pingleOfferImage"
                              //       />
                              //     </div>

                              //     {/* Content */}
                              //     <div className="mainDivPingleOfferCard d-flex flex-column align-items-center text-center flex-grow-1 p-2">

                              //       <div className="pingleOfferPointsDiv d-flex align-items-center justify-content-center primary-bg text-light px-3 py-2 mb-2">
                              //         <img
                              //           src={pingleUserIcon}
                              //           className="PingleLoyaltyIcon me-2"
                              //           alt="PLIcon"
                              //         />
                              //         <p className="m-0 ff-poppins-semiBold fs-12">
                              //           {offers.offer_price}
                              //         </p>
                              //       </div>

                              //       <p className="mb-1 ff-poppins-semiBold fs-12 text-truncate w-100" title={offers.offer_name}    >
                              //         {offers.offer_name}
                              //       </p>

                              //       <p className="pingleOfferExplainText">
                              //         {offers.offfer_description}
                              //       </p>

                              //       <button
                              //         className="pingleOfferRedeemBtnGreen primary-bg ff-poppins-semiBold fs-12 mt-auto"
                              //         onClick={() => setLoyaltyDetail(offers.offer_id)}
                              //       >
                              //         REDEEM
                              //       </button>
                              //     </div>
                              //   </div>
                              // </div>
                              <div className="col-6 px-1 mt-2 cardposition-relative" key={index}>
                                <div className="pingleOfferCardBox d-flex flex-column h-100 mx-1">
                                  <div className="offer-content d-flex flex-column  flex-grow-1 justify-content-between text-center p-2">
                                    <div className="offer-image-wrapper">
                                      <img src={offers.offer_images.length > 0 ? offers.offer_images[0] : placeholderImage}
                                        onError={(event) => {
                                          event.target.onerror = null;
                                          event.target.src = 'https://pingle.s3.ap-south-1.amazonaws.com/uploads/vendor/profile/user.jpg';
                                        }}
                                        alt="Offer" className="pingleOfferImage"
                                      />
                                    </div>
                                    <div>

                                      <div className="d-flex justify-content-center align-items-center ">
                                        <div className="d-flex justify-content-around align-items-center coinPingleBox pingleOfferPointsDiv primary-bg">
                                          <img src={pingleUserIcon} className="PingleLoyaltyIcon " style={{ width: 20, height: 20, }} alt="PLIcon" />
                                          <p className="m-0 ff-poppins-semiBold text-white  d-flex align-item-center fs-11">{offers?.offer_price}</p>
                                        </div>
                                      </div>

                                      <div className="offer-description mt-3 mb-2">
                                        <p className="fs-14 text-dark ff-poppins-semiBold"> {offers?.offer_name}  </p>
                                        <p className="fs-11 ff-poppins-regular" > {offers?.offfer_description?.length > 60 ?
                                          `${offers?.offfer_description.slice(0, 60)}...` : offers?.offfer_description}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="d-flex justify-content-center">
                                      <button className=" pingleOfferRedeemBtnGreen  primary-bg" onClick={() => setLoyaltyDetail(offers.offer_id)}>
                                        REDEEM
                                      </button>
                                    </div>
                                  </div>

                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                      : ""
                  }
                  {loyaltyData.referal_unlock_offers.length > 0 ?
                    <div className="pingleOfferHero">
                      <div className="pinglerOfferItemsCardsDiv">
                        <div className="fw-bold pb-3 fs-5">
                          {loyaltyData.referal_unlock_offers.length} Items to Unlock
                        </div>
                        <div className="row gx-0 px-0">
                          {loyaltyData.referal_unlock_offers?.map((offers, index) => (
                            <div className="col-6 container-fluid" key={index}>
                              <div className="col-12 d-flex flex-column mx-1 pingleOfferCardBox">
                                <div className="col-6 px-0 w-100">
                                  <img src={
                                    offers.offer_images.length > 0
                                      ? offers.offer_images[0]
                                      : placeholderImage
                                  }
                                    onError={(event) => { event.target.onerror = null; event.target.src = 'https://pingle.s3.ap-south-1.amazonaws.com/uploads/vendor/profile/user.jpg' }}
                                    // alt="Offer Image"
                                    className="pingleOfferImage"
                                  />
                                </div>
                                <div className="col-6 px-0 mainDivPingleOfferCard">
                                  <div className="pingleOfferPointsDiv d-flex justify-content-around primary-bg text-light p-1 ms-1 me-1">
                                    <img src={pingleUserIcon} className="PingleLoyaltyIcon ms-1 me-2" alt="PLIcon" />
                                    <p className="m-0 ms-1 ff-poppins-semiBold fs-12 ms-1 me-1">{offers.offer_price}</p>
                                  </div>
                                  {/* <p
                                    className="mt-3 mb-1 ff-poppins-semiBold fs-12"
                                    style={{
                                      textAlign: "center",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      width: "100%", // Adjust the width as needed
                                    }}
                                    title={offers.offer_name} // Shows the full text on hover
                                  >
                                    {offers.offer_name}
                                  </p>

                                  <p className="pingleOfferExplainText py-2"
                                    style={{ fontFamily: "Poppins-Light", fontSize: "11px", textAlign: "center", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", height: "60px", }}  >
                                    {offers.offfer_description}
                                  </p> */}

                                  <div className="offer-description mt-3 mb-2">
                                    <p className="fs-14 text-dark ff-poppins-semiBold"> {offers?.offer_name}  </p>
                                    <p className="fs-11 ff-poppins-regular" > {offers?.offfer_description?.length > 60 ?
                                      `${offers?.offfer_description.slice(0, 60)}...` : offers?.offfer_description}
                                    </p>
                                  </div>


                                  <button className="pingleOfferRedeemBtn">REDEEM</button>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                    : ""
                  }
                </>
                :
                <div>
                  <Lottie animationData={empotyLottie} />
                </div>

              :
              <div className="ReactLoading">
                <div className="spinner-border" role="status"  >
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
          }
        </div>
      </div>
    </div>
  );
};

export default LoyaltyOffer;
